import React from 'react';
import './AddService.css';
import Swal from 'sweetalert2';
import { useForm } from "react-hook-form";
import axios from 'axios';

const AddService = () => {
    const { register, handleSubmit, reset } = useForm();
    const onSubmit = data => {
        axios.post('https://serene-beach-92273.herokuapp.com/services', data)
            .then(function (res) {
                if (res.data.insertedId) {
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'success',
                        title: 'Service added successfully',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    reset();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    return (
        <div className='container'>
            <h2>Add a service</h2>
            <div className="add-service">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <input {...register("name", { required: true, maxLength: 20 })} placeholder='Service tilte' />
                    <input type="number" {...register("price")} placeholder='Price' />
                    <textarea {...register("description")} placeholder='Description' />
                    <input type='text' {...register("img")} placeholder='img url' />
                    <input className='btn btn-primary mt-5' type="submit" value='Add Service' />
                </form>
            </div>
        </div>
    );
};

export default AddService;